// Theme Management
export function initTheme() {
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme === 'light') {
    document.documentElement.classList.remove('dark');
  } else if (savedTheme === 'dark') {
    document.documentElement.classList.add('dark');
  } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
    document.documentElement.classList.remove('dark');
  } else {
    document.documentElement.classList.add('dark');
  }
  updateThemeLabel();
}

export function toggleTheme() {
  const isDark = document.documentElement.classList.contains('dark');
  if (isDark) {
    document.documentElement.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  } else {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  }
  updateThemeLabel();
}

export function updateThemeLabel() {
  const isDark = document.documentElement.classList.contains('dark');
  const label = document.getElementById('themeBtnLabel');
  if (label) {
    label.innerText = isDark ? 'light' : 'dark';
  }
}

// Attach globally for inline HTML events
window.toggleTheme = toggleTheme;

// Keyboard shortcuts
document.addEventListener('keydown', (e) => {
  if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) return;

  if (e.key === 't' || e.key === 'T') {
    toggleTheme();
  }
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initTheme();
});
initTheme();
